<template>
  <div class="search-modal">
    <form @submit.prevent="doSearch">
      <div class="container">
        <div class="row">
          <div class="col-12 p-0">
            <HMSearch
              v-model="search"
              :delay="0"
              @initialized="field => field.focus()"
            />
          </div>
        </div>
      </div>
      <HMModalFooter
        :submitButton="$t('GENERAL.BUTTON.SEARCH')"
        @close="$emit('close')"
      />
    </form>
  </div>
</template>

<script>
export default {
  name: 'HMSearchModal',
  components: {},
  props: {
    title: {
      type: String,
      default: 'GENERAL.TITLE.SEARCH',
    },
    onSearch: { type: Function },
  },
  data() {
    return {
      search: '',
    };
  },
  methods: {
    async doSearch() {
      this.onSearch(this.search);
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
